import { render } from "./allContracts.vue?vue&type=template&id=1845430c"
import script from "./allContracts.vue?vue&type=script&lang=js"
export * from "./allContracts.vue?vue&type=script&lang=js"

import "./allContracts.vue?vue&type=style&index=0&id=1845430c&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__